import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';

interface PageBrain {
  Title?: string;
  [key: string]: unknown;
}

interface ConteudoRelacionadoItem {
  label?: string;
  [key: string]: unknown;
}

/**
 * Ao escolher a página no campo Link, herda o título como rótulo — só
 * quando o rótulo está vazio (ver `AcoesRapidas/adapter.ts`). Um brain de
 * URL externa não tem `Title`, então nesse caso o rótulo continua exigindo
 * digitação manual — coerente com o RF07 (rótulo deve ser específico, não
 * um decalque do título da página de destino sem revisão editorial).
 */
export const buildConteudoRelacionadoFields = (
  page: PageBrain,
  item: ConteudoRelacionadoItem = {},
): Partial<ConteudoRelacionadoItem> =>
  !item.label && page.Title ? { label: page.Title } : {};

export const ConteudosRelacionadosBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}: {
  block: string;
  data: Record<string, unknown>;
  id: string;
  onChangeBlock: (block: string, data: unknown) => void;
  value: unknown;
}) => {
  blockAdapterBase(
    block,
    data,
    id,
    onChangeBlock,
    value,
    'items',
    buildConteudoRelacionadoFields,
  );
};

export default ConteudosRelacionadosBlockDataAdapter;
